export default __webpack_public_path__ + "static/media/phoenix1.f997273d.jpeg";